import { createContext } from 'react';

export type FlowVersion = '1.0' | '1.1' | '2.0' | '2.0-dev' | '2.1';

/**
 * A minor version drawn over its major's screens. Set around a flows page, it
 * turns every Flow asking for `from` into `to`, so 2.1 is 2.0's spec rendered
 * in 2.1's words without a second copy of seven hundred lines of screens.
 */
export const FlowVersionLayer = createContext<{
  from: FlowVersion;
  to: FlowVersion;
} | null>(null);
